module.exports = __webpack_public_path__ + "media/img/timestock22_1495149-309b6667.jpg";